<template>
  <div class="hello">
    <div class="headerbar" style="background-color:#202536;position: relative;top: -50px;">
    <!--图标-->
      <el-row height="50px">
        <el-col :span="4">
          <img src="static/logo.png" width="100%" height="100%">
        </el-col>
        <el-col :span="20">
          <h1 style="color:white;"> 低维体系数据库Low-Dimensional Systems (LODS: http://lods.org.cn/ ) </h1>
        </el-col>
      </el-row>
    </div>
    <div class="subdatabase" style="border-style: dotted;">
      <el-row> <h1> 子数据库 </h1></el-row>
      <el-row>
        <!-- a link to cluster website-->
        <!-- <button type="button" class="btn btn-primary" style="margin-left: 10px;margin-top: 10px;" > -->
          <a href="#"  onclick="window.open(`http://${window.location.hostname}/main_page_CN.html`)">
            <span class="glyphicon glyphicon-home"></span>
            <h3>Cluster DataBase</h3>
          </a>
          <!-- route to view-->
          <a href="#"  onclick="window.open(`http://${window.location.hostname}:8001/1D`)">
            <span class="glyphicon glyphicon-home"></span>
            <h3>1D Materials DataBase</h3>
          </a>
          <a href="#"  onclick="window.open(`http://${window.location.hostname}/#/view`)">
            <span class="glyphicon glyphicon-home"></span>
            <h3>2D Materials DataBase</h3>
          </a>
        <!-- </button> -->
      </el-row>
    </div>
    <h1>{{ msg }}</h1>
    <el-input placeholder="search" v-model="searchkey" v-if="false" >
    </el-input>
    <searchpanel v-model="searchkey"></searchpanel>
    <el-button type="primary" @click="search0()"  icon="el-icon-search"></el-button>
    <!--搜索结果-->
    <el-table :data="searchresult" >
      <el-table-column prop="id" label="ID" width=100 v-if="false"></el-table-column> <!--暂时不显示id-->
      <el-table-column prop="name" :sortable="true" label="Name" width=100></el-table-column>
      <el-table-column prop="tags" :sortable="true" label="Tags" width=100></el-table-column>
      <el-table-column prop="formula" :sortable="true" label="Formula" width=100></el-table-column>
      <el-table-column prop="spacegroup" :sortable="true" label="Spacegroup" width=100></el-table-column>
      <el-table-column prop="pointgroup" :sortable="true" label="Pointgroup" width=100></el-table-column>
      <el-table-column prop="energygap" :sortable="true" label="Energy Gap" width=100></el-table-column>
      <el-table-column prop="energyperatom" :sortable="true" label="Energy/atom" width=100></el-table-column>
      <el-table-column prop="nsites" :sortable="true" label="Nsites" width=100></el-table-column>
      <el-table-column label="View">
      <template slot-scope="scope">
        <el-button icon="el-icon-view" @click="viewit(scope.row.id)">
        </el-button>
      </template>
    </el-table-column>
    </el-table>
  </div>
</template>

<script>
import searchpanel from './searchpanel.vue'
export default {
  components: { searchpanel },
  name: 'mainpage',
  data () {
    var searchkey0 = '{}'
    // if (this.$route.query.search) {
    //   searchkey0 = this.$route.query.search
    // }
    return {
      msg: 'search structure',
      searchkey: searchkey0,
      searchresult: []
    }
  },
  mounted () {
    // 当访问自带search参数时直接搜索，所有seach都要转换成mongodb形式
    var searchkey0 = '{}'
    if (this.$route.query.search) {
      searchkey0 = this.$route.query.search
      this.searchkey = searchkey0
      console.log('searchkey', this.searchkey)
      this.search0()
    }
  },
  methods: {
    search0 () {
      this.$router.push({path: this.$route.path, query: {search: this.searchkey} });
      this.$ajax.get('/api/v0/structure', {params: {'search': this.searchkey}}).then(
        res => {
          var rdata = res.data
          console.log(typeof res)
          window.temp = res
          var newresult = []
          var getvars = function (object, key, default_value) {
            var result = object[key]
            return (typeof result !== 'undefined') ? result : default_value
          }
          for (var i = 0; i < rdata.length; i++) {
            // 搜索结果中的每一行
            newresult.push({
              id: rdata[i]._id.$oid,
              name: rdata[i].name,
              tags: rdata[i].tags.join(','),
              formula: rdata[i].formula,
              spacegroup: rdata[i].spaceGroupName,
              pointgroup: getvars(rdata[i].property, 'Point_Group', '-'),
              energygap: getvars(rdata[i].property, 'gap', '-'),
              energyperatom: rdata[i].property.energyPerAtom,
              nsites: rdata[i].numberOfAtoms
            })
          }
          // this.msg = rdata[0].name
          this.searchresult = newresult
        }
      )
    },
    viewit (it) {
      console.log(it)
      this.$router.push({
        path: '/structure/' + it
      }
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
div{
  font-family: BlinkMacSystemFont,-apple-system,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue","Helvetica","Arial",sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/mainpage.vue